import React from 'react';
import { useSelector } from 'react-redux';
import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	XIcon,
	TwitterShareButton,
} from 'react-share';
import { useNavigate, useLocation } from 'react-router-dom';

import { BaseUser } from '@common/typescript/objects/BaseUser';
import { BaseApplicationState } from '@common/react/store';

interface Props {
	size?: number;
}

const ShareLinks: React.FC<Props> = ({ size = 30 }) => {
	const reactLocation = useLocation();
	const hostOptions = useSelector((state: BaseApplicationState<BaseUser>) => state.hostOptions.item);
	const url = `${hostOptions?.hostServer || (typeof window !== 'undefined' ? location.hostname : '')}${reactLocation.pathname.slice(1)}`;

	return <div className="share-icons">
		<FacebookShareButton
			url={url}
		>
			<FacebookIcon size={size} round />
		</FacebookShareButton>
		<LinkedinShareButton
			url={url}
		>
			<LinkedinIcon size={size} round />
		</LinkedinShareButton>
		<TwitterShareButton
			url={url}
		>
			<XIcon size={size} round />
		</TwitterShareButton>
	</div>;
};

export default ShareLinks;
